import { ExtractComponentProp } from '@approvalmax/types';
import { Flex, ToggleButton } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { memo, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { amplitudeService } from 'services/amplitude';
import { routingService } from 'services/routing';
import { getPath, Path, Workspace } from 'urlBuilder';

import { messages } from './ToggleLoginRegister.messages';

export const ToggleLoginRegister = memo(() => {
    const { pathname } = useLocation();

    const [app] = hooks.useQueryParam<Workspace>('app');
    const [email] = hooks.useQueryParam('email');
    const defaultValue = pathname.split('/')[1];

    const onChange = useCallback<ExtractComponentProp<typeof ToggleButton.Group, 'onChange'>>(
        (value) => {
            if (value === Path.register) {
                routingService.replace(
                    getPath(Path.register, {
                        email,
                        app,
                    })
                );
            } else {
                routingService.replace(
                    getPath(Path.login, {
                        email,
                        workspace: app,
                    })
                );

                amplitudeService.sendData('signup: click on log in button');
            }
        },
        [app, email]
    );

    return (
        <Flex justifyContent='center'>
            <ToggleButton.Group name='page' color='midnight80' onChange={onChange} value={defaultValue}>
                <ToggleButton value={Path.register} width={104}>
                    {messages.registerText}
                </ToggleButton>

                <ToggleButton value={Path.login} width={104}>
                    {messages.loginText}
                </ToggleButton>
            </ToggleButton.Group>
        </Flex>
    );
});

ToggleLoginRegister.displayName = 'ToggleLoginRegister';
